import React, { useState, useEffect, useRef } from 'react'
import * as styles from "./HeroSection.module.scss";
import heroImage from "../../../images/on-going-projects/srinivasa/Cover.jpg";
import srinivasaLogo from "../../../images/on-going-projects/srinivasa/white-logo.png";
import Modal from "../../modal/Modal";
import ReraModal from "../enchanted/ReraModal";
import BrochureModal from "../enchanted/BrochureModal";
import brochurePdfUrl from "../../../images/on-going-projects/srinivasa/Srinivasa-e-brochure.pdf";
import VideoModal from "../enchanted/VideoModal";

function HeroSection() {
  const [showReraModal, setShowReraModal] = useState(false);
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const brochurePdfUrlRef = useRef(null);
  const reraPdfUrl = "/pdfs/Rera-Certificate.pdf";

  return (
    <div className={styles.heroSection} id="section-1">
        <img src={heroImage} alt="Hero Section" className={styles.heroImage} />
        <a href={brochurePdfUrl} ref={brochurePdfUrlRef} style={{display: "none"}} download />
        <div className={styles.overlayContainer}>
          <img src={srinivasaLogo} alt="Srinivasa Logo" className={styles.srinivasaLogo} />
          <div className={styles.blackShadow1}></div>
          <div className={styles.blackShadow2}></div>

          <div className={styles.heroText}>
            <div className={styles.heroTextHeading}>Your towering home embellished with an enchanting green screen</div>
            <div className={styles.heroTextEBrochureLink} style={{ cursor: 'pointer' }} onClick={() => setShowBrochureModal(true)}>E BROCHURE</div>
            <div className={styles.reraText} style={{ cursor: 'pointer' }} onClick={() => setShowReraModal(true)}>TN/29/Building/0189/2025</div>
            <div className={styles.reraText}>www.rera.tn.gov.in</div>
            <div className={styles.btnContainer} style={{ cursor: 'pointer' }} onClick={() => setShowVideoModal(true)}>
            Click to Play Video
            </div>
          </div>
        </div>

        <ReraModal
          showReraModal={showReraModal}
          setShowReraModal={setShowReraModal}
          pdfUrl={reraPdfUrl}
        />

        <BrochureModal
          showBrochureModal={showBrochureModal}
          setShowBrochureModal={setShowBrochureModal}
          brochurePdfUrlRef={brochurePdfUrlRef}
          pdfUrl={brochurePdfUrl}
          scriptUrl={'https://script.google.com/macros/s/AKfycbykS9v9vMDalOUWVGsbJ9naW6PiNJqrzype9SZ2_nRqNCveAZsfv2BdxpwK5qZPLUx7/exec'}
        />

        <VideoModal
          showVideoModal={showVideoModal}
          setShowVideoModal={setShowVideoModal}
          videoUrl={'https://www.youtube.com/embed/dIn-sYpG4bI'}
        />
    </div>
  )
}

export default HeroSection